import { render } from "./SecondaryNavigationBar.vue?vue&type=template&id=28e309b9"
import script from "./SecondaryNavigationBar.vue?vue&type=script&lang=js"
export * from "./SecondaryNavigationBar.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__